(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9245],{

/***/ 7099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ subscribe; }
/* harmony export */ });
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2920);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3952);


const subscribe = async (email, navigate, param)=>{
    let { group , r  } = param;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
        email,
        groups: group ? [
            group
        ] : undefined,
        fields: r ? {
            r
        } : undefined
    });
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw
    };
    try {
        const res = await fetch("/api/subscribe", requestOptions);
        if (res.status === 201) {
            navigate("/confirm?email=" + email);
            return;
        }
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(JSON.stringify(res));
        (0,react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .Am)("Something went wrong. Please try again later.", {
            type: "error"
        });
    } catch (err) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(err);
        (0,react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .Am)("Something went wrong. Please try again later.", {
            type: "error"
        });
    }
};


/***/ }),

/***/ 9513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Comments; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./utils/use-script.js

// we need a function that accepts the script src and couple of other parameters
let initialized = false;
const useScript = (params)=>{
    const { url , theme , issueTerm , repo , ref  } = params;
    const [status, setStatus] = (0,react.useState)(url ? "loading" : "idle");
    // run the useEffect when the url of the script changes
    (0,react.useEffect)(()=>{
        if (!url) {
            setStatus("idle");
            return;
        }
        if (initialized) {
            return;
        }
        let script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.crossOrigin = "anonymous";
        script.setAttribute("theme", theme);
        script.setAttribute("issue-term", issueTerm);
        script.setAttribute("repo", repo);
        // Add script to document body
        ref.current.appendChild(script);
        // store status of the script
        const setAttributeStatus = (event)=>{
            /**
         * Console.log value from event
            {
                bubbles: false
                cancelBubble: false
                cancelable: false
                composed: false
                currentTarget: null
                defaultPrevented: false
                eventPhase: 0
                isTrusted: true
                path: [script]
                returnValue: true
                srcElement: null
                target: null
                timeStamp: 276483.5
                type: "load"
            }

            based on the type property we will get know whether script is ready or errored out
            */ setStatus(event.type === "load" ? "ready" : "error");
        };
        script.addEventListener("load", setAttributeStatus);
        script.addEventListener("error", setAttributeStatus);
        initialized = true;
        return ()=>{
            // useEffect clean up
            if (script) {
                script.removeEventListener("load", setAttributeStatus);
                script.removeEventListener("error", setAttributeStatus);
            }
        };
    }, [
        url
    ]);
    return status;
};
/* harmony default export */ var use_script = (useScript);

;// CONCATENATED MODULE: ./components/Comments/Comments.js



const Comments = ()=>{
    const comment = (0,react.useRef)(null);
    const status = use_script({
        url: "https://utteranc.es/client.js",
        theme: "github-light",
        issueTerm: "pathname",
        repo: "Altruisto/devsforgood-comments",
        ref: comment
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: comment
        })
    });
};


/***/ }),

/***/ 375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ContentAuthor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6963);
/* harmony import */ var _ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const authors = {
    daniel: {
        name: "Daniel Wyrzykowski",
        image: "daniel-w.jpeg",
        description: "Founder @ Devs for Good"
    },
    kinga: {
        name: "Kinga Gomulka",
        image: "kinga-g.jpeg",
        description: "Content Creator @ Devs for Good"
    },
    luiza: {
        name: "Luiza Pietraszko",
        image: "luiza-p.jpeg",
        description: "Content Creator @ Devs for Good"
    }
};
const ContentAuthor = (param)=>{
    let { who  } = param;
    if (Array.isArray(who)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2___default().authors),
            children: who.map((author)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentAuthor, {
                    who: author
                }, author))
        });
    }
    const { name , image , description  } = authors[who];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2___default().author),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                className: (_ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2___default().authorImage),
                src: "/authors/".concat(image),
                alt: name,
                width: 50,
                height: 50
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2___default().authorName),
                        children: name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ContentAuthor_module_scss__WEBPACK_IMPORTED_MODULE_2___default().authorDescription),
                        children: description
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ContentThroughSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ContentThroughSection_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2919);
/* harmony import */ var _ContentThroughSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ContentThroughSection_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3566);




const ContentThroughSection = (param)=>{
    let { children =/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlogPostsDefault, {})  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ContentThroughSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_ContentThroughSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
            children: children
        })
    });
};
const BlogPostsDefault = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .E.div, {
                className: (_ContentThroughSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                initial: {
                    opacity: 0,
                    scale: 0.5
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                transition: {
                    duration: 0.3,
                    type: "spring",
                    stiffness: 400,
                    damping: 40,
                    mass: 1
                },
                children: [
                    "Get deals on books, courses, software.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "All profits go to charities."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                className: (_ContentThroughSection_module_scss__WEBPACK_IMPORTED_MODULE_2___default().ctaButton),
                href: "/?from=through-section",
                children: "Find out more."
            })
        ]
    });


/***/ }),

/***/ 9050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ExitIntentMat; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _SubscribeForm_SubscribeForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6523);
/* harmony import */ var _ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6964);
/* harmony import */ var _ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var use_exit_intent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3295);






const saveToLocalStorage = ()=>{
    localStorage.setItem("exit-intent-date", new Date().toISOString());
};
const getFromLocalStorage = ()=>{
    const date = localStorage.getItem("exit-intent-date");
    if (date) {
        const parsedDate = new Date(date);
        const now = new Date();
        const diff = now.getTime() - parsedDate.getTime();
        const diffInMinutes = diff / 1000 / 60;
        return diffInMinutes > 60;
    }
    return true;
};
const ExitIntentMat = ()=>{
    const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { registerHandler  } = (0,use_exit_intent__WEBPACK_IMPORTED_MODULE_4__/* .useExitIntent */ .a)({
        mobile: {
            triggerOnIdle: true,
            delayInSecondsToTrigger: 5
        }
    });
    registerHandler({
        id: "exit-intent-mat",
        handler: ()=>{
            if (getFromLocalStorage()) {
                setShow(true);
                saveToLocalStorage();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), {
            [(_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().show)]: show
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                    children: "Wait! Before you go..."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description),
                    children: [
                        "Grab Exclusive Deals for Books, Courses, Software.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: "100% of Profits Are Donated"
                        }),
                        " To Research-Backed Charities."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SubscribeForm_SubscribeForm__WEBPACK_IMPORTED_MODULE_2__/* .SubscribeForm */ .g, {
                    rootClassName: (_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().form),
                    inputClassName: (_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().input),
                    buttonClassName: (_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: (_ExitIntentMat_module_scss__WEBPACK_IMPORTED_MODULE_5___default().dismiss),
                    onClick: ()=>{
                        setShow(false);
                    },
                    children: "No thank you!"
                })
            ]
        })
    });
};


/***/ }),

/***/ 3944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3642);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Footer_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const Footer = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_1___default().root),
        children: [
            "Made with ❤ in Warsaw, Berlin, Rotherham.",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_1___default().info),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                    children: [
                        "Well-Managed World C.I.C.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "Unit 4e Enterprise Court",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "Farfield Park, Rotherham",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "South Yorkshire",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "S63 5DB, England",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/privacy-policy",
                            children: "Privacy Policy"
                        }),
                        "\xa0 | \xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/terms-of-service",
                            children: "Terms of Service"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 7478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ShareContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6573);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1020);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6616);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7385);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8168);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4276);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2834);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9275);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3597);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7332);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8137);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6339);
/* harmony import */ var _ShareContent_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2603);
/* harmony import */ var _ShareContent_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ShareContent_module_scss__WEBPACK_IMPORTED_MODULE_1__);



const ShareContent = (param)=>/*#__PURE__*/ {
    let { shareUrl , title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ShareContent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().share),
        children: [
            "Help us raise more money for charities by sharing this page ♥️",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_ShareContent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().shareButtons),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        url: shareUrl,
                        quote: title,
                        className: (_ShareContent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().shareButton),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 48,
                            round: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        url: shareUrl,
                        title: title,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            size: 48,
                            round: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        url: shareUrl,
                        title: title,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            size: 48,
                            round: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        url: shareUrl,
                        title: title,
                        separator: ":: ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            size: 48,
                            round: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        url: shareUrl,
                        title: title,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            size: 48,
                            round: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        url: shareUrl,
                        subject: title,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            size: 48,
                            round: true
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 6523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ SubscribeForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _api_client_subscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7099);




const SubscribeForm = (param)=>{
    let { buttonClassName , inputClassName , rootClassName , buttonLabel ="Yes, I want to join!" , group  } = param;
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const navigate = (path)=>router.push(path);
    const r = router.query.r;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: rootClassName,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "email",
                placeholder: "Enter your email",
                className: inputClassName,
                value: email,
                onChange: (e)=>setEmail(e.target.value)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: buttonClassName,
                onClick: ()=>{
                    (0,_api_client_subscribe__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .L)(email, navigate, {
                        group,
                        r
                    });
                },
                children: buttonLabel
            })
        ]
    });
};


/***/ }),

/***/ 9495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ContentLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_ExitIntentMat_ExitIntentMat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9050);
/* harmony import */ var _Layout_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4257);
/* harmony import */ var _Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_ShareContent_ShareContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7478);
/* harmony import */ var _components_Comments_Comments__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9513);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3944);










const variantToLogo = {
    primary: "/logo-white.png",
    white: "/logo.png"
};
const defaultMeta = {
    title: "Devs for Good",
    description: "Help others & grow as a dev"
};
const ContentLayout = (param)=>{
    let { children , variant , textVariant ="large" , meta  } = param;
    const { title , description , image , authors , url  } = {
        ...defaultMeta,
        ...meta
    };
    const currentUrl =  true ? window.location.href : 0;
    const shareUrl = (meta === null || meta === void 0 ? void 0 : meta.url) || currentUrl || "https://devsforgood.com";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@devsforgood"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: authors === null || authors === void 0 ? void 0 : authors.join(", ")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: image
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default().nav), {
                            [(_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["nav--white"])]: variant === "white"
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default().navContainer),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: variantToLogo[variant],
                                        alt: "Logo",
                                        width: 300,
                                        height: 120
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/?from=nav-button",
                                    className: (_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default().navButton),
                                    children: "Help others & grow as a dev"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default().main), {
                            [(_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["main--small-font"])]: textVariant === "small"
                        }),
                        children: [
                            children,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ShareContent_ShareContent__WEBPACK_IMPORTED_MODULE_6__/* .ShareContent */ .X, {
                                shareUrl: shareUrl,
                                title: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Layout_module_scss__WEBPACK_IMPORTED_MODULE_9___default().comments),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Comments_Comments__WEBPACK_IMPORTED_MODULE_7__/* .Comments */ .H, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ExitIntentMat_ExitIntentMat__WEBPACK_IMPORTED_MODULE_4__/* .ExitIntentMat */ .K, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_8__/* .Footer */ .$, {})
        ]
    });
};


/***/ }),

/***/ 6963:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authors":"ContentAuthor_authors__VZZXK","author":"ContentAuthor_author__RWKCg","authorImage":"ContentAuthor_authorImage__0ieoj","authorName":"ContentAuthor_authorName__VtSs1","authorDescription":"ContentAuthor_authorDescription__IfVHj"};

/***/ }),

/***/ 2919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"ContentThroughSection_section__HL3jW","container":"ContentThroughSection_container__2j0B1","title":"ContentThroughSection_title__l4_XW","ctaButton":"ContentThroughSection_ctaButton__lRjNM"};

/***/ }),

/***/ 6964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ExitIntentMat_main__EVOft","show":"ExitIntentMat_show__2ctFN","title":"ExitIntentMat_title__A2Pgl","description":"ExitIntentMat_description__wlzIw","form":"ExitIntentMat_form__sgE1F","input":"ExitIntentMat_input__tIxjr","button":"ExitIntentMat_button__2I1Q3","dismiss":"ExitIntentMat_dismiss__djbj4"};

/***/ }),

/***/ 3642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__a62C1","info":"Footer_info__iYhms"};

/***/ }),

/***/ 2603:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"share":"ShareContent_share__Y2cFk","shareButtons":"ShareContent_shareButtons__VXkP6"};

/***/ }),

/***/ 4257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__XhcgP","nav":"Layout_nav__syB0s","nav--white":"Layout_nav--white__Hw_tH","navContainer":"Layout_navContainer__aW_QK","navLogo":"Layout_navLogo__AQNnT","navButton":"Layout_navButton__AcNMS","main":"Layout_main__SOsyQ","main--small-font":"Layout_main--small-font__cu1iZ","comments":"Layout_comments__0RSst"};

/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; }
/* harmony export */ });
/* unused harmony exports MDXContext, withMDXComponents, MDXProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return React.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return React.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ })

}]);